import React from "react";
import { useFunctiesContext } from "./Context/FunctiesContext";
import { Card, CardBody, FormGroup, Label } from "reactstrap";

export default function Gymbevoegdheid() {
	const { gymnastiekValue, functiesData, setGymnastiekValue, updateGymnastiekValue } =
		useFunctiesContext();
	return (
		<div className="col-lg-6">
			<Card className="main-card">
				<CardBody className="d-flex flex-column">
					<h5 className="mb-4">Gymbevoegdheid</h5>
					<FormGroup className="form-element">
						<Label for="link">Gymnastiek</Label>
						<select
							className="form-select"
							value={gymnastiekValue || functiesData?.eGym}
							onChange={(e) => {
								setGymnastiekValue(e.target.value);
								updateGymnastiekValue(e.target.value);
							}}
						>
							<option value={""}>Selecteer</option>
							<option value="Nee">Nee</option>
							<option value="Ja">Ja</option>
							<option value="i.o.">In opleiding</option>
						</select>
					</FormGroup>
				</CardBody>
			</Card>
		</div>
	);
}
